import React from 'react';
import { motion } from 'framer-motion';
import Lianna from '../assets/images/Lianna.jpg';
import { useLanguage } from '../context/LanguageContext';

const About = () => {
  const { t } = useLanguage();

  return (
    <div className="pt-32 pb-24 min-h-screen bg-secondary/30">
      <div className="container mx-auto px-6 md:px-12">
        <div className="flex flex-col lg:flex-row gap-16 items-center">
          <motion.div initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }} className="w-full lg:w-1/2">
            <img src={Lianna} alt={t('about.imageAlt')} className="w-full h-[700px] object-cover shadow-soft grayscale hover:grayscale-0 transition-all duration-700" />
          </motion.div>
          <motion.div initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.8, delay: 0.2 }} className="w-full lg:w-1/2">
            <h4 className="uppercase tracking-widest text-accent text-sm font-semibold mb-4">{t('about.eyebrow')}</h4>
            <h1 className="font-serif text-5xl mb-8">{t('about.title')}</h1>
            <div className="space-y-6 text-text-light leading-relaxed">
              <p>{t('about.paragraph1')}</p>
              <p>{t('about.paragraph2')}</p>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default About;
